/**
 * Custom Product Swiper for Responsive View
 * Only active on screens 1100px and below
 */
window.CustomProductSwiper = class CustomProductSwiper {
  constructor(container) {
    this.container = container;
    this.wrapper = container.querySelector('.custom-swiper-container');
    this.slides = Array.from(container.querySelectorAll('.custom-swiper-slide'));
    this.prevButton = container.querySelector('.custom-swiper-button-prev');
    this.nextButton = container.querySelector('.custom-swiper-button-next');
    this.pagination = container.querySelector('.custom-swiper-pagination');
    // Find thumbnails container - it's a sibling of custom-swiper-wrapper inside the same custom-product-swiper
    const swiperParent = container.closest('.custom-product-swiper');
    this.thumbnailsContainer = swiperParent ? swiperParent.querySelector('.custom-swiper-thumbnails') : null;
    this.thumbnails = this.thumbnailsContainer ? Array.from(this.thumbnailsContainer.querySelectorAll('.custom-swiper-thumbnail')) : [];
    
    this.currentIndex = 0;
    this.isTransitioning = false;
    this.touchStartX = 0;
    this.touchEndX = 0;
    
    if (this.slides.length <= 1) {
      // Hide navigation if only one slide
      if (this.prevButton) this.prevButton.style.display = 'none';
      if (this.nextButton) this.nextButton.style.display = 'none';
      if (this.pagination) this.pagination.style.display = 'none';
      if (this.thumbnailsContainer) this.thumbnailsContainer.style.display = 'none';
      return;
    }
    
    this.init();
  }
  
  init() {
    this.createPagination();
    this.updateButtons();
    this.updateThumbnails();
    this.attachEventListeners();
    this.goToSlide(0, false); // Initialize first slide
  }
  
  createPagination() {
    if (!this.pagination) return;
    
    this.pagination.innerHTML = '';
    this.slides.forEach((_, index) => {
      const bullet = document.createElement('span');
      bullet.className = 'custom-swiper-pagination-bullet';
      if (index === 0) {
        bullet.classList.add('active');
      }
      bullet.addEventListener('click', () => this.goToSlide(index));
      this.pagination.appendChild(bullet);
    });
  }
  
  updateButtons() {
    if (this.prevButton) {
      if (this.currentIndex === 0) {
        this.prevButton.classList.add('disabled');
      } else {
        this.prevButton.classList.remove('disabled');
      }
    }
    
    if (this.nextButton) {
      if (this.currentIndex === this.slides.length - 1) {
        this.nextButton.classList.add('disabled');
      } else {
        this.nextButton.classList.remove('disabled');
      }
    }
  }
  
  updatePagination() {
    if (!this.pagination) return;
    
    const bullets = this.pagination.querySelectorAll('.custom-swiper-pagination-bullet');
    bullets.forEach((bullet, index) => {
      if (index === this.currentIndex) {
        bullet.classList.add('active');
      } else {
        bullet.classList.remove('active');
      }
    });
  }
  
  updateThumbnails() {
    this.thumbnails.forEach((thumbnail, index) => {
      if (index === this.currentIndex) {
        thumbnail.classList.add('active');
      } else {
        thumbnail.classList.remove('active');
      }
    });
  }
  
  goToSlide(index, animate = true) {
    if (this.isTransitioning || index < 0 || index >= this.slides.length) return;
    
    this.isTransitioning = true;
    this.currentIndex = index;
    
    const translateX = -index * 100;
    
    if (animate) {
      this.wrapper.style.transition = 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
    } else {
      this.wrapper.style.transition = 'none';
    }
    
    this.wrapper.style.transform = `translateX(${translateX}%)`;
    
    this.updateButtons();
    this.updatePagination();
    this.updateThumbnails();
    
    // Reset transition flag after animation
    if (animate) {
      setTimeout(() => {
        this.isTransitioning = false;
      }, 400);
    } else {
      this.isTransitioning = false;
    }
  }
  
  nextSlide() {
    if (this.currentIndex < this.slides.length - 1) {
      this.goToSlide(this.currentIndex + 1);
    }
  }
  
  prevSlide() {
    if (this.currentIndex > 0) {
      this.goToSlide(this.currentIndex - 1);
    }
  }
  
  attachEventListeners() {
    // Button events
    if (this.prevButton) {
      this.prevButton.addEventListener('click', () => this.prevSlide());
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('click', () => this.nextSlide());
    }
    
    // Thumbnail events
    this.thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener('click', () => this.goToSlide(index));
    });
    
    // Touch events for mobile swipe
    let touchStartX = 0;
    let touchStartY = 0;
    let touchEndX = 0;
    let touchEndY = 0;
    
    this.container.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
      touchStartY = e.changedTouches[0].screenY;
    }, { passive: true });
    
    this.container.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      touchEndY = e.changedTouches[0].screenY;
      this.handleSwipe(touchStartX, touchEndX, touchStartY, touchEndY);
    }, { passive: true });
    
    // Keyboard navigation
    this.container.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.prevSlide();
      } else if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.nextSlide();
      }
    });
    
    // Make container focusable for keyboard navigation
    this.container.setAttribute('tabindex', '0');
  }
  
  handleSwipe(startX, endX, startY, endY) {
    const deltaX = endX - startX;
    const deltaY = endY - startY;
    const minSwipeDistance = 50;
    
    // Check if horizontal swipe is greater than vertical (to avoid conflicts with scrolling)
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > minSwipeDistance) {
      if (deltaX > 0) {
        // Swipe right - go to previous
        this.prevSlide();
      } else {
        // Swipe left - go to next
        this.nextSlide();
      }
    }
  }
  
  destroy() {
    // Clean up event listeners if needed
    if (this.prevButton) {
      this.prevButton.replaceWith(this.prevButton.cloneNode(true));
    }
    if (this.nextButton) {
      this.nextButton.replaceWith(this.nextButton.cloneNode(true));
    }
  }
}

// Initialize swipers when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCustomSwipers);
} else {
  initCustomSwipers();
}

function initCustomSwipers() {
  const swiperContainers = document.querySelectorAll('.custom-product-swiper');
  
  swiperContainers.forEach(container => {
    // Only initialize if screen width is 1100px or less
    const initSwiper = () => {
      if (window.innerWidth <= 1100) {
        if (!container.swiperInstance) {
          try {
            container.swiperInstance = new window.CustomProductSwiper(container);
          } catch (error) {
            console.error('Error initializing custom swiper:', error);
          }
        }
      } else {
        // Destroy swiper if screen is larger than 1100px
        if (container.swiperInstance) {
          try {
            container.swiperInstance.destroy();
            container.swiperInstance = null;
          } catch (error) {
            console.error('Error destroying custom swiper:', error);
          }
        }
      }
    };
    
    // Initialize on load
    initSwiper();
    
    // Re-initialize on resize
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        initSwiper();
      }, 250);
    };
    
    window.addEventListener('resize', handleResize);
    
    // Listen for re-initialization events (for variant changes)
    container.addEventListener('swiper:reinit', () => {
      if (container.swiperInstance) {
        container.swiperInstance.destroy();
        container.swiperInstance = null;
      }
      initSwiper();
    });
    
    // Store cleanup function
    container._cleanup = () => {
      window.removeEventListener('resize', handleResize);
      if (container.swiperInstance) {
        container.swiperInstance.destroy();
        container.swiperInstance = null;
      }
    };
  });
}

// Export function to re-initialize a specific swiper
window.reinitCustomSwiper = function(container) {
  if (container && container.swiperInstance) {
    container.swiperInstance.destroy();
    container.swiperInstance = null;
  }
  if (container && window.innerWidth <= 1100) {
    try {
      container.swiperInstance = new window.CustomProductSwiper(container);
    } catch (error) {
      console.error('Error re-initializing custom swiper:', error);
    }
  }
};

